import { executeButtonAction } from "../a51autocomplete/executeButtonActions";

/*global tinymce, jQuery */

;(function (tinymce, $, Popper) {
    'use strict';

    var A51AutoComplete = function (ed, options, reActivate) {
        this.editor = ed;

        this.options = $.extend({}, {
            source: [],
            delay: 500,
              minChar: 0,
            queryBy: 'name',
            items: 10
        }, options);

        this.matcher = this.options.matcher || this.matcher;
        this.renderDropdown = this.options.renderDropdown || this.renderDropdown;
        this.render = this.options.render || this.render;
        this.insert = this.options.insert || this.insert;
        this.highlighter = this.options.highlighter || this.highlighter;
        this.has_matches = false;
        this.buttonAction = this.options.buttonAction || this.buttonAction;

        this.query = '';
        this.hasFocus = true;

        this.renderInput(reActivate);

        this.bindEvents();
    };

    A51AutoComplete.prototype = {

        constructor: A51AutoComplete,

        renderInput: function (reActivate) {
            if (reActivate) {
                var range = this.editor.selection.getRng(true);
                range.setStart(range.startContainer, range.startOffset - 1);
                this.editor.selection.setRng(range);
            }

            const rawHtmlClassName = this.options.delimiter === '@' ? 'autocomplete-result' : '';

            var rawHtml =  `<span id="autocomplete-wrapper" class="${rawHtmlClassName}">` +
                                '<span id="autocomplete-delimiter">' + this.options.delimiter + '</span>' +
                                '<span id="autocomplete-searchtext"><span class="dummy">\u200B</span></span>' +
                            '</span>';

            this.editor.execCommand('mceInsertContent', false, rawHtml);
            this.editor.focus();
            this.editor.selection.select(this.editor.selection.dom.select('span#autocomplete-searchtext span')[0]);
            this.editor.selection.collapse(false);
        },

        bindEvents: function () {
            this.editor.on('keyup', this.editorKeyUpProxy = $.proxy(this.rteKeyUp, this));
            this.editor.on('keydown', this.editorKeyDownProxy = $.proxy(this.rteKeyDown, this), true);
            this.editor.on('click', this.editorClickProxy = $.proxy(this.rteClicked, this));

            $('body').on('click', this.bodyClickProxy = $.proxy(this.rteLostFocus, this));
        },

        unbindEvents: function () {
            this.editor.off('keyup', this.editorKeyUpProxy);
            this.editor.off('keydown', this.editorKeyDownProxy);
            this.editor.off('click', this.editorClickProxy);

            $('body').off('click', this.bodyClickProxy);
        },

        rteKeyUp: function (e) {
            switch (e.which || e.keyCode) {
            //DOWN ARROW
            case 40:
            //UP ARROW
            case 38:
            //SHIFT
            case 16:
            //CTRL
            case 17:
            //ALT
            case 18:
                break;

            //BACKSPACE
            case 8:
                if (this.query === '') {
                    this.cleanUp();
                    this.rollback();
                } else {
                    this.lookup();
                }
                break;

            //TAB
            case 9:
            //ENTER
            case 13:
                var item = (this.$dropdown !== undefined) ? this.$dropdown.find('li.active') : [];
                if (item.length && this.has_matches) {
                    this.select(item.data());
                    this.cleanUp();
                } else {
                    this.cleanUp();
                    this.rollback();
                }
                break;

            //ESC
            case 27:
                this.cleanUp();
                this.rollback();
                break;

            default:
                this.lookup();
            }
        },

        rteKeyDown: function (e) {
            switch (e.which || e.keyCode) {
             //TAB
            case 9:
            //ENTER
            case 13:
            //ESC
            case 27:
                e.preventDefault();
                break;

            //UP ARROW
            case 38:
                e.preventDefault();
                if (this.$dropdown !== undefined) {
                    this.highlightPreviousResult();
                }
                break;
            //DOWN ARROW
            case 40:
                e.preventDefault();
                if (this.$dropdown !== undefined) {
                    this.highlightNextResult();
                }
                break;

            // SPACEBAR
            case 32:
                this.cleanUp();
                this.rollback();
                break;
            }

            e.stopImmediatePropagation();
        },

        rteClicked: function (e) {
            var $target = $(e.target);

            if (this.hasFocus && $target.parent().attr('id') !== 'autocomplete-searchtext') {
                this.cleanUp();
                this.rollback();
            }
        },

        rteLostFocus: function (ed, e) {
            if (this.hasFocus) {
                this.cleanUp();
                this.rollback();
            }
        },

        lookup: function () {
            this.query = $.trim($(this.editor.getBody()).find("#autocomplete-searchtext").text()).replace('\u200B', '');
            var delimiterSpan = this.editor.dom.select("span#autocomplete-delimiter")[0];
            var hasValidDelimiter = delimiterSpan && delimiterSpan.innerHTML === this.options.delimiter;

            if (this.$dropdown === undefined && hasValidDelimiter) {
                this.initDropdown();
            } else if ((this.$dropdown !== undefined && !hasValidDelimiter)) {
                this.cleanUp();
                this.rollback();
                return;
            }

          if (this.query.length >= this.options.minChar) {
              clearTimeout(this.searchTimeout);
              this.searchTimeout = setTimeout($.proxy(function () {
    	          // Added delimiter parameter as last argument for backwards compatibility.
    	          var items = $.isFunction(this.options.source) ? this.options.source(this.query, $.proxy(this.process, this), this.options.delimiter) : this.options.source;

    	          if (items) {
    		          this.process(items);
    	          }
              }, this), this.options.delay);
          }

        },

        matcher: function (item) {
            return ~item[this.options.queryBy].toLowerCase().indexOf(this.query.toLowerCase());
        },

        sorter: function (items) {
            var beginswith = [],
                caseSensitive = [],
                caseInsensitive = [],
                item;

            while ((item = items.shift()) !== undefined) {
                if (!item[this.options.queryBy].toLowerCase().indexOf(this.query.toLowerCase())) {
                    beginswith.push(item);
                } else if (~item[this.options.queryBy].indexOf(this.query)) {
                    caseSensitive.push(item);
                } else {
                    caseInsensitive.push(item);
                }
            }

            return beginswith.concat(caseSensitive, caseInsensitive);
        },

        highlighter: function (text) {
            return text.replace(new RegExp('(' + this.query.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1") + ')', 'ig'), function ($1, match) {
                return '<strong>' + match + '</strong>';
            });
        },

        initDropdown: function () {
            var parent = $(this.editor.getBody()).parent();
            var dropdown = $(this.renderDropdown());

            parent.append(dropdown);

            $(dropdown).on('click', $.proxy(this.autoCompleteClick, this));

            var reference = $(parent).find('#autocomplete-wrapper')[0];
            var popup = $(dropdown)[0];

            var popperInstance = Popper.createPopper(reference, popup, {
                placement: "bottom-start"
            });
            this.$popper = popperInstance;

            this.$dropdown = dropdown;
        },

        process: function (data) {
            if (!this.hasFocus) {
                return;
            }

            var _this = this,
                result = [],
                items = $.grep(data, function (item) {
                    return _this.matcher(item);
                });

            items = _this.sorter(items);

            items = items.slice(0, this.options.items);

            $.each(items, function (i, item) {
                var $element = $(_this.render(item, _this.options.delimiter));

                $element.html($element.html().replace($element.text(), _this.highlighter($element.text())));

                $.each(items[i], function (key, val) {
                    $element.attr('data-' + key, val);
                });

                result.push($element[0].outerHTML);
            });

            if (result.length) {
                this.$dropdown.html(result.join('')).show();
                this.has_matches = true;
                this.highlightNextResult();
                this.$popper.update();
            } else {
                this.has_matches = false;
                this.$dropdown.hide();
            }
        },

        renderDropdown: function () {
            return '<ul class="rte-autocomplete dropdown-menu"><li class="loading"></li></ul>';
        },

        render: function (item, delimiter) {
            return '<li>' +
                        '<a href="javascript:;"><span>' + item[this.options.queryBy] + '</span></a>' +
                    '</li>';
        },

        autoCompleteClick: function (e) {
            var item = $(e.target).closest('li').data();
            if (!$.isEmptyObject(item)) {
                this.select(item);
                this.cleanUp(false);
            }
            e.stopPropagation();
            e.preventDefault();
        },

        highlightPreviousResult: function () {
            var currentIndex = this.$dropdown.find('li.active').index(),
                index = (currentIndex === 0) ? this.$dropdown.find('li').length - 1 : --currentIndex;

            this.$dropdown.find('li').removeClass('active').eq(index).addClass('active');
        },

        highlightNextResult: function () {
            var currentIndex = this.$dropdown.find('li.active').index(),
                index = (currentIndex === this.$dropdown.find('li').length - 1) ? 0 : ++currentIndex;

            this.$dropdown.find('li').removeClass('active').eq(index).addClass('active');
        },

        select: function (item) {
            this.editor.focus();

            this.editor.selection.select(this.editor.selection.dom.select('span#autocomplete-wrapper')[0]);
            this.editor.execCommand('delete');

            if (item?.button) {
                const button = this.buttonAction(item, this.options.delimiter);

                if (button) {
                  executeButtonAction(this.editor, button)
                }
            } else {
                this.editor.execCommand('mceInsertContent', false, this.insert(item, this.options.delimiter) + '&nbsp;');
            }
        },

        insert: function (item, delimiter) {
            return '<span>' + item[this.options.queryBy] + '</span>';
        },

        executeItemCommand: function (item, delimiter) {
            return item?.command ? item.command : null;
        },

        cleanUp: function () {
            this.unbindEvents();
            this.hasFocus = false;

            if (this.$dropdown !== undefined) {
                this.$dropdown.remove();
                delete this.$dropdown;
            }
        },

        rollback: function () {
            var text = this.query,
                $selection = $(this.editor.dom.select('span#autocomplete-wrapper')),
                replacement = $('<p>' + this.options.delimiter + text + '</p>')[0].firstChild,
                focus = $(this.editor.selection.getNode()).offset().top === ($selection?.offset()?.top + (($selection?.outerHeight() - $selection?.height()) / 2));

            this.editor.dom.replace(replacement, $selection[0]);

            if (focus) {
                this.editor.selection.select(replacement);
                this.editor.selection.collapse();
            }
        },

        offset: function () {
            var rtePosition = $(this.editor.getContainer()).offset(),
                contentAreaPosition = $(this.editor.getContentAreaContainer()).position(),
                nodePosition = $(this.editor.dom.select('span#autocomplete-wrapper')).position();

            return {
                top: rtePosition.top + contentAreaPosition.top + nodePosition.top + $(this.editor.selection.getNode()).innerHeight() - $(this.editor.getDoc()).scrollTop() + 5,
                left: rtePosition.left + contentAreaPosition.left + nodePosition.left
            };
        },

        offsetInline: function () {
            var nodePosition = $(this.editor.dom.select('span#autocomplete-wrapper')).offset();

            return {
                top: nodePosition.top + $(this.editor.selection.getNode()).innerHeight() + 5,
                left: nodePosition.left
            };
        }

    };

    tinymce.PluginManager.add('a51autocomplete', function(ed, url) {
      var autoComplete,
        autoCompleteData = ed.getParam('a51autocomplete');

      // If the delimiter is undefined set default value to ['@'].
      // If the delimiter is a string value convert it to an array. (backwards compatibility)
      autoCompleteData.delimiter = (autoCompleteData.delimiter !== undefined) ? !$.isArray(autoCompleteData.delimiter) ? [autoCompleteData.delimiter] : autoCompleteData.delimiter : ['@'];

      /**
       * Return character in front of carret
       *
       * @return {String}
       */
      function getPrevChar() {
        var start = ed.selection.getRng(true).startOffset,
          text = ed.selection.getRng(true).startContainer.data || '',

          charachter = start > 0 ? text.charAt(start - 1) : '';

        return $.trim(charachter);
      }

      function getPrevSecondChar() {
        var start = ed.selection.getRng(true).startOffset,
          text = ed.selection.getRng(true).startContainer.data || '',

          charachter = start > 0 ? text.charAt(start - 2) : '';

        return $.trim(charachter);
      }

      function prevCharIsSpace() {
        return (!!getPrevChar().length) ? false : true;
      }

      ed.on('input', function (e) {
        var reActivate = false;
        var delimiterIndex = $.inArray(e.data, autoCompleteData.delimiter);

        // var reActivate = prevCharIsDelimiter();

        if (delimiterIndex < 0) {
          var prevChar = getPrevChar();
          delimiterIndex = $.inArray(prevChar, autoCompleteData.delimiter);
          if (delimiterIndex > -1) reActivate = true;
        }

        if (getPrevSecondChar()?.length !== 0) {
          delimiterIndex = -1;
        }

        if (delimiterIndex > -1) {
          if (!reActivate) {
            var editorRange = ed.selection.getRng(); // get range object for the current caret position
            var node = editorRange.commonAncestorContainer; // relative node to the selection
            var range = document.createRange(); // create a new range object for the deletion
            range.selectNodeContents(node);
            range.setStart(node, editorRange.endOffset - 1); // current caret pos - 1
            range.setEnd(node, editorRange.endOffset); // current caret pos
            range.deleteContents();
            ed.focus(); // brings focus back to the editor
          }

          if (autoComplete === undefined || (autoComplete.hasFocus !== undefined && !autoComplete.hasFocus)) {
            autoComplete = new A51AutoComplete(ed, $.extend({}, autoCompleteData, { delimiter: autoCompleteData.delimiter[delimiterIndex] }), reActivate);
          }
        }
      });
    });

})(tinymce, jQuery, Popper);
